export const PaymentMethodTypeEnum = {
  CASH: 'cash',
  CREDIT_CARD: 'creditCard',
  BUSINESS_DISPATCH_INVOICE: 'businessAccount',
};
